import { render, staticRenderFns } from "./TributeDebugInfo.vue?vue&type=template&id=ed46efc2&scoped=true"
import script from "./TributeDebugInfo.vue?vue&type=script&lang=js"
export * from "./TributeDebugInfo.vue?vue&type=script&lang=js"
import style0 from "./TributeDebugInfo.vue?vue&type=style&index=0&id=ed46efc2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed46efc2",
  null
  
)

export default component.exports